import React from "react";
import { Route, Router, IndexRoute, browserHistory } from "react-router";

import AppContainer from "../components/containers/AppContainer";
import Home from "../components/containers/Home";
import BBCreamContainer from "../components/containers/BBCreamContainer";
import PhytoContainer from "../components/containers/PhytoContainer";
import PPeelContainer from "../components/containers/ppeel/PPeelContainer";
import TestimonialsContainer from "../components/containers/TestimonialsContainer";
import BeforeAfterContainer from "../components/containers/beforeAfters/BeforeAfterContainer";
import SocialMediaContainer from "../components/containers/SocialMediaContainer";
import AboutContainer from "../components/containers/about/AboutContainer";
import NewsContainer from "../components/containers/news/NewsContainer";
import HarpersBazaar2015 from "../components/containers/news/blogs/HarpersBazaar2015";
import Wellbeing2013 from "../components/containers/news/blogs/Wellbeing2013";
import Signature2012 from "../components/containers/news/blogs/Signature2012";
import Jetstar2015 from "../components/containers/news/blogs/Jetstar2015";
import DifferenceHap from "../components/containers/news/blogs/DifferenceHap";
import DifferentPerspective from "../components/containers/news/blogs/DifferentPerspective";
import TheDifference from "../components/containers/news/blogs/TheDifference";

const routes = (
	<Router history={ browserHistory } >
		<Route path="/" component={ AppContainer }>
			<IndexRoute component={ Home } />
			<Route path="/bb-cream" component={ BBCreamContainer } />
			<Route path="/b-peel" component={ PhytoContainer } />
			<Route path="/p-peel" component={ PPeelContainer } />
			<Route path="/testimonials" component={ TestimonialsContainer } />
			<Route path="/success-stories" component={ BeforeAfterContainer } />
			<Route path="/social-media" component={ SocialMediaContainer } />
			<Route path="/about" component={ AboutContainer } />
			<Route path="/news" component={ NewsContainer } />
			<Route path="/harpers-bazaar-2015" component={ HarpersBazaar2015 } />
			<Route path="/wellbeing-2013" component={ Wellbeing2013 } />
			<Route path="/signature-2012" component={ Signature2012 } />
			<Route path="/jetstar-2015" component={ Jetstar2015 } />
			<Route path="/difference-hap" component={ DifferenceHap } />
			<Route path="/different-perpective" component={ DifferentPerspective } />
			<Route path="/the-difference" component={ TheDifference } />
		</Route>
	</Router>
);

export default routes;



/** WEBPACK FOOTER **
 ** ./src/core/routes.jsx
 **/